import React, { FC, memo } from 'react';
import { FormItem, useFiltersLabel, FiltersNameEnum, FilterDrawerType } from '@blocs.filter';
import { AutofillByRoleCriteria as AutofillByRoleCriteriaFilter } from '../../../FilterCollection';
import { initialFilters } from '../../shared/config';
import { FilterDrawerProps } from '../../shared/types';

type Props = {
  roleId: number;
  type: FilterDrawerType;
  getAdditionalAutofillFilters?: FilterDrawerProps['getAdditionalAutofillFilters'];
};

const AutofillByRoleCriteria: FC<Props> = ({ roleId, type, getAdditionalAutofillFilters }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  return (
    <FormItem $fullWidth>
      <AutofillByRoleCriteriaFilter
        autofillByRoleCriteriaName={FiltersNameEnum.autofillByRoleCriteria}
        unionStatusName={FiltersNameEnum.unionStatus}
        excludeUnionStatusName={FiltersNameEnum.excludeUnionStatus}
        genderName={FiltersNameEnum.gender}
        additionallyIdentifiesAsName={FiltersNameEnum.additionallyIdentifiesAs}
        ethnicAppearanceName={FiltersNameEnum.ethnicAppearance}
        switchAgeToMonthsName={FiltersNameEnum.switchTo}
        playableAgeRangeName={FiltersNameEnum.playableAgeRange}
        playableAgeMinName={FiltersNameEnum.min}
        playableAgeMaxName={FiltersNameEnum.max}
        workingLocationName={FiltersNameEnum.workingLocation}
        label={filtersLabelOfAudience[FiltersNameEnum.autofillByRoleCriteria]}
        type={type}
        roleId={roleId}
        initialFilters={initialFilters[type]}
        getAdditionalAutofillFilters={getAdditionalAutofillFilters}
      />
    </FormItem>
  );
};

export default memo(AutofillByRoleCriteria);
